import type { OrganizationEnvironmentResourceReadApi } from '@ingenico/api-sdk-device-management-private-v2';
import type { OrganizationEnvironment } from '../../models/organizationEnvironment.model';

export function mapUpdateEnvironmentByOrganizationIdResponse(
  response: OrganizationEnvironmentResourceReadApi,
): OrganizationEnvironment {
  return response;
}
